import { render, staticRenderFns } from "./widgetSecThreatSearch.vue?vue&type=template&id=402e6fd3&scoped=true&"
import script from "./widgetSecThreatSearch.vue?vue&type=script&lang=js&"
export * from "./widgetSecThreatSearch.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecThreatSearch.vue?vue&type=style&index=0&id=402e6fd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e6fd3",
  null
  
)

export default component.exports